import $ from 'jquery'
import { actionSelect } from './selector'
import {Core} from "./core.js";

const $body = $('body')
export const mktoDomain = '//go.cegid.com'
const classFormStylised = 'marketo-form-stylised'
const dataMarketoId = 'data-marketo-id'
const dataMarketoThankYou = 'data-marketo-thank-you'
const dataMarketoType = 'data-marketo-type'
const dataMarketoFormId = 'data-marketo-form-id'
const dataMarketoSteps = 'data-marketo-steps'
const podId = '//app-lon04.marketo.com'
const dataWrapperFor = 'data-wrapper-for'
const fieldOrder = ['Mkto_email_simple_opt_in__c', 'OptIn_c']
const classesSteps = {
  stepsGenerated: 'mkto-steps-generated',
  step: 'mkto-step',
  steps: 'mkto-steps',
  stepsContent: 'mkto-steps-content',
  fields: 'mkto-step-fields',
  bottom: 'mkto-step-bottom',
  breadcrumb: 'mkto-step-breadcrumb',
  breadcrumbTop: 'mkto-step-breadcrumb-top',
  breadcrumbBottom: 'mkto-step-breadcrumb-bottom',
  cta: 'mkto-step-cta',
  button: 'mkto-step-button',
  invalidInput: 'mktoInvalid',
  errorMsg: 'mktoError',
}

$(document).ready(function () {
  if (typeof MktoForms2 !== 'undefined') {
    initMktoForm()

    if (! Core.isAdmin()) {
      $( 'body' ).on('DOMSubtreeModified', initMktoForm )
    }
  }
})

function initMktoForm () {
  let forms = document.querySelectorAll(`[${dataMarketoId}]:not(.${classFormStylised}`)

  if (forms.length === 0) {
    return;
  }

  forms.forEach(function (formEl) {
    if ( formEl.classList.contains(classFormStylised) ) {
      return
    }

    formEl.classList.add(classFormStylised)

    let munchkinId = formEl.getAttribute(dataMarketoId)
    let formId = formEl.getAttribute('id').replace('mktoForm_','')

    MktoForms2.loadForm(podId, munchkinId, formId, function (form) {
      form.onSuccess(function (values, followUpUrl) {

        // Fix for IB products forms freemium (33369, 33371, 33370)
        // DiezFAC: https://www.cegid.com/ib/es/productos/programa-facturacion-pymes-autonomos/ = 33371
        // DiezNOM: https://www.cegid.com/ib/es/productos/software-gestion-nominas-asesorias/ = 33370
        // DiezCON: https://www.cegid.com/ib/es/productos/programa-contabilidad-pymes-autonomos/ = 33369
        if( formId == 33369 || formId == 33371 || formId == 33370 ){
          return false;
        }

        let new_url = formEl.getAttribute(dataMarketoThankYou);

        if (new_url !== null && new_url.length > 4) {
          form.getFormElem().hide();
          location.href = formEl.getAttribute(dataMarketoThankYou);
          return false;
        }
      });
    })
  })

  MktoForms2.whenReady(mktoFormWhenReady)

  MktoForms2.whenRendered(mktoFormWhenRendered)
}

function mktoFormWhenRendered (form) {
  let formEl = form.getFormElem()[0]
  let $form = $(formEl)

  $form.find('label').each((index, label) => {
    let $label = $(label)
    let labelFor = $label.attr('for')

    if ($(`body #${labelFor}`).length > 1) {
      let uniqId = Math.random().toString(36).substring(2, 9) + index
      $form.find(`[for="${labelFor}"]`).attr('for', `${labelFor}_${uniqId}`)
      $form.find(`#${labelFor}`).attr('id', `${labelFor}_${uniqId}`)
    }
  })

  // Generate fake select
  handleUpdateHtmlForm()

  // form.onValidate(function(isValid){
  //   if (!isValid) {
  //     /**
  //      * On vérifie les erreurs de validation
  //      */
  //     if ($form.attr(dataMarketoSteps)) {
  //       let $errors = $form.find(`.${classesSteps.invalidInput}`)
  //
  //       if ($errors.length > 0) {
  //         let index = 1000
  //         $errors.each((indexError, error) => {
  //           let $step = $(error).closest(`.${classesSteps.step}`)
  //           let currentIndex = $step.index()
  //
  //           if (currentIndex < index) {
  //             index = currentIndex
  //           }
  //         })
  //
  //         let $steps = $errors.closest(`.${classesSteps.stepsContent}`)
  //         let $stepToShow = $steps.find(`.${classesSteps.step}:nth-child(${index+1})`)
  //
  //         goToStep($steps, $stepToShow, false)
  //       }
  //     }
  //   }
  // })

  $form.on('click', `.${classesSteps.breadcrumbBottom} span.active`, function (e) {
    e.preventDefault()

    let $elt = $(e.target)
    let searchIndex = $elt.attr('data-index')
    let $steps = $elt.closest(`.${classesSteps.stepsContent}`)
    let $stepToShow = $steps.find(`.${classesSteps.step}:nth-child(${searchIndex})`)

    goToStep($steps, $stepToShow, false)
  })

  $form.on('click', `.${classesSteps.button}`, function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $steps = $(e.currentTarget).closest(`.${classesSteps.stepsContent}`)
    let $activeStep = $steps.find(`.${classesSteps.step}.active`)
    let $nextStep = $activeStep.find(`+ .${classesSteps.step}`)

    form.validate()

    if (! hasErrorsOnActiveStep($activeStep)) {
      goToStep($steps, $nextStep, true)
    }
  })
}

function hasErrorsOnActiveStep($step) {
  return $step.find(`.${classesSteps.invalidInput}`).length > 0
}

function mktoFormWhenReady (form) {
  let formEl = form.getFormElem()[0]
  let $form = $(formEl)

  addDataAttributToContainers($form)
  deleteStyleOnElementOfForm($form)

  updateOrderPositionField($form)

  if ($form.attr(dataMarketoSteps)) {
    generateSteps($form)
  }

  destyleMktoForm(formEl)
  removeEmptyLabel($form)

  $('.mktoLogicalField').each(function () {
    let $parent = $(this).parent('.mktoFieldWrap')

    if ($parent.find('input').length > 1) {
      $parent.addClass('mkto-checkbox-list')
    } else {
      $parent.addClass('mkto-checkbox')
    }
  })

  // START Rich text for interet legitime
  // cc https://app.asana.com/0/1200024003728903/1201935445404883/f
  $('.mktoForm .interet-legitime').each(function () {
    $(this).closest('.mktoFormRow').css('order', 9)
  })
  // END Rich text for interet legitime

  // Generate fake select
  updateSelectStyle()

  // Disable loader
  $('.spinner').removeClass('active')

  $form.on('change', handleFormUpdated)

  $(window).on('resize', () => {
    deleteStyleOnElementOfForm($form)
    setTimeout(() => {
      deleteStyleOnElementOfForm($form)
    }, 150)
  })
}

function removeEmptyLabel ($form) {
  let notInSelector = fieldOrder.map(function (fieldName) {
    return `[${dataWrapperFor}="${fieldName.toLowerCase()}"] *`
  })

  let classLabel = `.mktoFormRow label:not(${notInSelector.join(', ')})`

  $form.find(classLabel).each((index, label) => {
    let $label = $(label)
    if ($label.text().trim() === '*') {
      $label.remove()
    }
  })
}

function handleFormUpdated (e) {
  deleteStyleOnElementOfForm($(e.currentTarget))
  updateSelectStyle()
}

function handleUpdateHtmlForm (e) {
  updateSelectStyle()
}
function updateSelectStyle () {
  // Generate fake select
  $('.mktoFieldWrap select').each(actionSelect)
}

function deleteStyleOnElementOfForm ($form) {
  $form.removeAttr('style')
  $form.find('[style]:not(.g-recaptcha, .g-recaptcha *, .mktoRangeField *, .mkto-steps *)').removeAttr('style')
}

function addDataAttributToContainers ($form) {
  let $container = $form.find('.mktoFormRow')

  $container.each(addDataAttributToContainer)
}

function addDataAttributToContainer (index, item) {
  let $item = $(item)
  let name = $item.find('input, textarea, select').attr('name')

  if (name) {
    $item.attr(dataWrapperFor, name.toLowerCase())
  }
}

function updateOrderPositionField ($form) {
  let $buttonRow = $form.find('.mktoButtonRow')

  fieldOrder.map(function (fieldName) {
    return $form.find(`.mktoFormRow[${dataWrapperFor}="${fieldName.toLowerCase()}"]`)
  }).forEach(function (fieldRow) {
    !fieldRow || fieldRow.insertBefore($buttonRow)
  })
}

function destyleMktoForm (formEl) {
  let arrayify = getSelection.call.bind([].slice)

  // disable remote stylesheets and local <style>s
  let styleSheets = arrayify(document.styleSheets)
  styleSheets.forEach(function (ss) {
    if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
      ss.disabled = true
    }
  })

  // Delete style inline (attribut style)
  let styledEls = formEl.querySelectorAll('[style]:not(.g-recaptcha, .g-recaptcha *, .mktoRangeField *, .mkto-steps *)')
  for (let i = 0; i < styledEls.length; i++) {
    let el = styledEls[i]
    el.removeAttribute('style')
  }
  // Delete style inline (style in head)
  for (let i = 0; i < document.styleSheets.length; i++) {
    let sheet = document.styleSheets[i]
    try {
      let rules = sheet.cssRules
      if (rules) {
        if (rules.length > 0) {
          if (rules[0].selectorText && rules[0].selectorText.indexOf('mktoForm') != -1) {
            sheet.disabled = true
          }
        }
      }
    } catch (err) {}
    if (formEl.contains(sheet.ownerNode)) {
      sheet.disabled = true
    }
  }

  formEl.setAttribute('data-styles-ready', 'true')
}

function generateSteps($form) {
  if ($form.hasClass(classesSteps.stepsGenerated)) {
    return
  }
  $form.addClass(classesSteps.stepsGenerated)

  $form.append(`<div class="${classesSteps.steps}"><div class="${classesSteps.stepsContent}"></div></div>`)

  let form_id = $form.attr(dataMarketoFormId)
  let steps = $(`#mktoForm_steps_${form_id}`).text()
  let $steps = $form.find(`.${classesSteps.stepsContent}`)

  steps = JSON.parse(steps)

  let nbrSteps = steps.length

  steps.forEach((step, indexStep) => {
    $steps.append(getStepTemplate())

    let $step = $steps.find(`.${classesSteps.step}:last-child`)

    $step.data('step', indexStep + 1)

    if (indexStep === 0) {
      $step.addClass('active')
    }

    let $stepFields = $step.find(`.${classesSteps.fields}`)

    step.fields.forEach((field, indexField) => {
      $stepFields.append($form.find(`[data-wrapper-for="${field}"]`))
    })

    let $stepBreadcrumbTop = $step.find(`.${classesSteps.breadcrumbTop}`)

    $stepBreadcrumbTop.append(`${indexStep + 1}&nbsp;/&nbsp;${nbrSteps}`)

    let $stepBreadcrumbBottom = $step.find(`.${classesSteps.breadcrumbBottom}`)

    for (let i = 0;i < steps.length; i++) {
      $stepBreadcrumbBottom.append(`<span data-index="${i+1}"></span>`)

      if (i <= indexStep) {
        $stepBreadcrumbBottom.find(`span:last-child`).addClass('active')
      }
    }

    let $stepCta = $step.find(`.${classesSteps.cta}`)

    if (step.buttonStep) {
      $stepCta.append(`<div class="${classesSteps.button} btn btn-accent">${step.buttonStep}</div>`)
    } else {
      $stepCta.append($form.find(`[data-wrapper-for="${step.submitButton}"]`))
    }
  })
}

function goToStep($steps, $stepToShow, hideErrors) {
  let $activeStep = $steps.find(`.${classesSteps.step}.active`)

  $activeStep.removeClass('active')

  if ($stepToShow.length > 0) {
    if (hideErrors) {
      $stepToShow.find(`.${classesSteps.invalidInput}`).removeClass('mktoInvalid')
      $stepToShow.find(`.${classesSteps.errorMsg}`).remove()
    }

    $stepToShow.addClass('active')
  } else {
    $steps.find(`.${classesSteps.step}:first-child`).addClass('active')
  }
}

/**
 * @returns {string}
 */
function getStepTemplate() {
  return `<div class="${classesSteps.step}">
      <div class="${classesSteps.fields}"></div>
      <div class="${classesSteps.bottom}">
        <div class="${classesSteps.breadcrumb}">
          <div class="${classesSteps.breadcrumbTop}"></div>
          <div class="${classesSteps.breadcrumbBottom}"></div>
        </div>
        <div class="${classesSteps.cta}"></div>
      </div>
    </div>`
}
